<template>
  <div v-if="!closeModal"  class="fixed right-0 h-screen top-0 w-screen z-50">
    <div class="absolute top-0 left-0 w-full h-full bg-black opacity-50" @click="closeModal = true"></div>
    <div class="absolute right-[2vw] xl:right-0 top-0 bg-white xl:h-full  w-[96vw] xl:max-w-[400px] z-10 p-6 flex flex-col">
      <div class="flex items-center justify-between mb-6">
        <h2 class="text-2xl font-bold">{{ i18n.t('marketplace.items_show.added_to_cart') }}</h2>
        <i class="bi bi-x-lg cursor-pointer text-xl" @click="closeModal = true"></i>
      </div>
      <div class="flex items-center gap-4 mb-12">
        <img v-if="item.attributes.main_image" :src="item.attributes.main_image" class="object-cover aspect-square w-16 rounded-xl" />
        <div v-else class="aspect-square w-16 flex items-center justify-center rounded-xl bg-gray-100">
          <span class="fa-stack text-[24px] opacity-20 ">
            <i class="fa-image far fa-stack-1x" aria-hidden="true"></i>
            <i class="fa-slash fas icon-stack-base fa-stack-1x " aria-hidden="true"></i>
          </span>
        </div>
        <h6 class="block truncate font-bold">{{ item.attributes.name }}</h6>
        <div class="ml-auto text-xl font-bold shrink-0"></div>
      </div>
      <div v-if="accessories.length > 0" class="font-bold text-lg">{{ i18n.t('marketplace.items_show.need_any_addons') }}</div>
      <div class="mt-4 grow overflow-y-auto">
        <SmallCard v-for="accessory in accessories" :addedItems="addedItems" :key="accessory.id" :item="accessory" @addItem="bookItem" />
      </div>
      <div class="mt-4 shrink-0 flex flex-col gap-4 items-center justify-center pb-32">
        <a :href="cartUrl" class="jt-btn jt-mk-btn w-full" @click="$emit('addItem', item)">{{ i18n.t('marketplace.items_show.view_cart') }}</a>
        <a v-if="false" href="/marketplace/items" class="w-full underline block text-center font-bold" @click="$emit('addItem', item)">{{ i18n.t('marketplace.items_show.continue_shopping') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import SmallCard from './small_card.vue';

export default {
  name: 'Accessories',
  props: {
    item: Object,
    cart: Object,
  },
  components: {
    SmallCard
  },
  data: function() {
    return {
      accessories: [],
      addedItems: [],
      itemAddedToCart: false,
      closeModal: false
    }
  },
  computed: {
    cartUrl() {
      return this.cart.urls?.checkout
    }
  },
  mounted() {
    this.getAccessories();
  },
  methods: {
    getAccessories() {
      fetch(this.item.attributes.urls.accessories)
        .then(response => response.json())
        .then(data => {
          this.accessories = data.data
        })
    },
    bookItem(id) {
      window.topNavigation?.$refs.topNavigation.updateCart(
        id,
        1
      )
      const integerId = parseInt(id, 10)
      this.addedItems.push(integerId)
      setTimeout(() => {
        this.addedItems = this.addedItems.filter(itemId => itemId !== integerId)
      }, 3000)
    }
  }
}
</script>
